import React from "react";
import { Form, Field } from "react-final-form";

import Button from "@components/Button";
import InputRadio from "@components/Form/Radio";

const FeedbackForm = ({ submitFeedback }) => (
  <Form
    onSubmit={submitFeedback}
    render={({ handleSubmit, submitting }) => (
      <form onSubmit={handleSubmit} noValidate={true}>
        <div className="block text-base mb-2">
          <Field
            name="feedback"
            component={InputRadio}
            label="Informatii mai usor de inteles"
            type="radio"
            value="Informatii mai usor de inteles"
          />
        </div>

        <div className="block text-base">
          <Field
            name="feedback"
            component={InputRadio}
            label="Informatii mai relevante"
            type="radio"
            value="Informatii mai relevante"
          />
        </div>

        <div className="mt-6 mb-3">
          <Button
            display="inline"
            disabled={submitting}
            type="submit"
            title={`Trimite`}
          />
        </div>
      </form>
    )}
  />
);

export default FeedbackForm;
